import React from 'react'
import { UiCol } from "../../components/grid-container/GridContainer"
import PropTypes from 'prop-types';


export default function UiHowSherbetWorkCol(props) {

    return (
        <>
            <UiCol lg="4" sm="6" className="sb-how-sherbet-work__col">
                <div className="sb-how-sherbet-work__col-img">
                    <img src={props.image} className="sb-how-sherbet-work-img"/>
                </div>
                <h4>{props.heading}</h4>
                <p>{props.body} </p>
            </UiCol>
        </>
    )
}
UiHowSherbetWorkCol.propTypes = {
    image: PropTypes.string,
    heading: PropTypes.string,
    body: PropTypes.string,
};
